// extracted by mini-css-extract-plugin
module.exports = {"ai-assistant-nav-item":"mobile-ai-assistant-nav_ai-assistant-nav-item__wRRr7"};